import React from "react";

const Loading = () => {
    return (
        <div className="loading w-full h-screen bg-primary absolute top-0 left-0 z-[999] overflow-hidden">
            <div className="Lato-font loading-text w-full h-full flex justify-center items-center text-light text-xl font-bold gap-2">
                <div className="loading-items w-4 h-4 bg-light rounded-full"></div>
                <div className="loading-items w-4 h-4 bg-light rounded-full"></div>
                <div className="loading-items w-4 h-4 bg-light rounded-full"></div>
            </div>
        </div>
    )
}

export default Loading